import React from "react";
import { Box, Tooltip } from "@mui/joy";
import type { Dive, FollowUpSheet } from "../../../api/followup/Followup.typed";
import FollowUpSummaryModal from "../../followup/FollowUpSummaryModal";
import { AnalyticsIcon } from "../../../styles/StyledMUI";
import IconButtonCTA from "../../common/IconButtonCTA";
import { roundActionIconButtonSx } from "../../../styles/globalStyles";

interface FollowUpComponentProps {
  customerId?: number;
  trainingTemplateId?: number;
  followUpSheet?: FollowUpSheet;
  dives?: Dive[];
}

export default function FollowUpComponent({
  customerId,
  trainingTemplateId,
  followUpSheet,
  dives,
}: FollowUpComponentProps) {
  const [openModal, setOpenModal] = React.useState(false);

  return (
    <Box sx={{ padding: 1, textAlign: "center" }}>
      <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", my: 1 }}>
        <Tooltip title="Ouvrir la fiche de suivi">
          <IconButtonCTA
            onClick={() => setOpenModal(true)}
            size="lg"
            ctaVariant="accent"
            aria-label="Ouvrir la fiche de suivi"
            sx={{
              ...roundActionIconButtonSx,
              margin: 1,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <AnalyticsIcon />
          </IconButtonCTA>
        </Tooltip>
      </Box>

      <FollowUpSummaryModal
        open={openModal}
        onClose={() => setOpenModal(false)}
        customerId={customerId}
        trainingTemplateId={trainingTemplateId}
        followUpSheet={followUpSheet}
        dives={dives}
      />
    </Box>
  );
}
